import type { RouteRecordRaw } from 'vue-router';

/**
 * Parties (customers & suppliers) routes, kept in their own file per the M1 parallel-work
 * convention (catalog/parties/etc. screens land without touching each other's route blocks) —
 * `router.ts` only spreads this array into the app-shell `children`.
 */
export const partyRoutes: RouteRecordRaw[] = [
  {
    path: 'parties',
    name: 'parties-list',
    component: () => import('../pages/parties/PartiesListPage.vue'),
    meta: { requiresModule: 'parties' },
  },
  {
    path: 'parties/payment-terms',
    name: 'parties-payment-terms',
    component: () => import('../pages/parties/PaymentTermsPage.vue'),
    meta: { requiresModule: 'parties' },
  },
  {
    path: 'parties/:id',
    name: 'parties-detail',
    component: () => import('../pages/parties/PartyDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'parties' },
  },
];
